import { Component, Input, Output, EventEmitter, ViewChild, ChangeDetectionStrategy } from '@angular/core';
import { NgxFileDropEntry, FileSystemFileEntry } from 'ngx-file-drop';
import { BooksService } from '../../core/services/data/books.service';
import { AnalyticsService } from '../../core/services/analytics.service';

@Component({
	selector: 'app-file-drop',
	templateUrl: './file-drop.component.html',
	styleUrls: ['./file-drop.component.scss'],
	changeDetection: ChangeDetectionStrategy.Eager,
	standalone: false,
})
export class FileDropComponent {
	@Input() bookUrl;

	@Output() loading = new EventEmitter();

	@Output() bookUploadData = new EventEmitter();

	@Output() bookUploadError = new EventEmitter();

	@ViewChild('fileInput') fileInput;

	public files: NgxFileDropEntry[] = [];

	constructor(
		private bs: BooksService,
		private as: AnalyticsService,
	) {}

	public dropped(event) {
		this.isLoading(true);
		this.files = event.target.files;
		for (const droppedFile of event.target.files) {
			// Is it a file?
			if (droppedFile.fileEntry.isFile) {
				const fileEntry = droppedFile.fileEntry as FileSystemFileEntry;
				fileEntry.file((file: File) => {
					const ext = file.name.split('.').pop().toLowerCase();
					if (['jpeg', 'jpg', 'webp', 'png', 'gif', 'bmp'].indexOf(ext) === -1) {
						this.isLoading(false);
						this.uploadError(['Invalid file. Upload one of the supported extensions: jpeg, jpg, png, gif, bmp, or webp.']);
						return;
					}

					if (file.size > 12000000) {
						this.isLoading(false);
						this.uploadError(['File Size Limit of 12MB Exceeded']);
						return;
					}

					// upload it
					const formData = new FormData();
					formData.append('file', file, droppedFile.relativePath);

					this.bs.uploadBookCover(formData).subscribe((result: any) => {
						if (result.success) {
							this.uploadData(result.data);
							this.isLoading(false);
							const eventProps = {
								fileName: result.data.fileName,
							};
							this.as.trackEvent('Book Cover Upload', eventProps);
							this.as.trackGTMEvent('book_cover_upload', eventProps);
						} else {
							this.uploadError(['Upload Error. Something went wrong.']);
							this.isLoading(false);
						}
					});
				});
			}
		}
	}

	public openFileChooseDialog() {
		this.fileInput.nativeElement.click();
	}

	fileChanged(event) {
		this.isLoading(true);
		const list: FileList = event.target.files;
		const numberOfFilesFound: number = list.length;

		if (numberOfFilesFound === 0) {
			this.isLoading(false);
		}

		for (let i = 0; i < numberOfFilesFound; i++) {
			const file: File = list.item(i);

			const ext = file.name.split('.').pop().toLowerCase();
			if (['jpeg', 'jpg', 'webp', 'png', 'gif', 'bmp'].indexOf(ext) === -1) {
				this.isLoading(false);
				this.uploadError(['Invalid file. Upload one of the supported extensions: jpeg, jpg, png, gif, bmp, or webp.']);
				return;
			}

			if (file.size > 12000000) {
				this.isLoading(false);
				this.uploadError(['Your book cover image is over 12MB which is the maximum amount our system accepts.'
					+ ' Please upload a smaller version to continue.']);
				return;
			}

			// upload it
			const formData = new FormData();
			formData.append('file', file, file.name);

			this.bs.uploadBookCover(formData).subscribe((result: any) => {
				if (result.success) {
					this.uploadData(result.data);
					this.isLoading(false);
					const eventProps = {
						fileName: result.data.fileName,
					};
					this.as.trackEvent('Book Cover Upload', eventProps);
					this.as.trackGTMEvent('book_cover_upload', eventProps);
				} else {
					this.uploadError(['Upload Error. Something went wrong.']);
					this.isLoading(false);
				}
			});
		}
	}

	uploadData(data) {
		this.bookUploadData.emit(data);
	}

	uploadError(data) {
		this.bookUploadError.emit(data);
	}

	isLoading(val) {
		this.loading.emit(val);
	}

	public fileOver(event) {

	}

	public fileLeave(event) {

	}
}
